/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileSizeEndpointResponse
 */
export interface FileSizeEndpointResponse {
    /**
     * 
     * @type {number}
     * @memberof FileSizeEndpointResponse
     */
    totalSize: number;
}

export function FileSizeEndpointResponseFromJSON(json: any): FileSizeEndpointResponse {
    return FileSizeEndpointResponseFromJSONTyped(json, false);
}

export function FileSizeEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileSizeEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalSize': json['total_size'],
    };
}

export function FileSizeEndpointResponseToJSON(value?: FileSizeEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_size': value.totalSize,
    };
}


